var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { CloudFunctions } from "../FirebaseAuth/firebase";
import { AuthContext } from "../FirebaseAuth";
import { legacyLtiOperators } from "../../pages/auth/superAdmins";
import Loader from '../Loader';
import Alert from "../Alert";
var EnableLegacyLTI = function (props) {
    var _a;
    var enabled = props.enabled, accountId = props.accountId;
    var _b = React.useState(null), errorMessage = _b[0], setErrorMessage = _b[1];
    var _c = React.useState(false), inSubmit = _c[0], setInSubmit = _c[1];
    var authUser = React.useContext(AuthContext).authUser;
    var enableLegacyLTI = function () { return __awaiter(void 0, void 0, void 0, function () {
        var setDefaultKey;
        return __generator(this, function (_a) {
            setInSubmit(true);
            setErrorMessage(null);
            setDefaultKey = CloudFunctions.httpsCallable('oncall');
            setDefaultKey({
                name: "setDefaultKey",
                data: {
                    accountId: accountId
                }
            }).then(function (res) {
                if (res.data.hasOwnProperty("error")) {
                    setErrorMessage(res.data.error);
                    setInSubmit(false);
                    return;
                }
                // Reload so the new feature flag (OAuth Secrets card) and the
                // "Deploy Needed" banner (bumped lastSave) are picked up.
                window.location.reload();
            }).catch(function (err) {
                setErrorMessage(err.message);
                setInSubmit(false);
            });
            return [2 /*return*/];
        });
    }); };
    if (!((_a = authUser.user) === null || _a === void 0 ? void 0 : _a.uid) || !legacyLtiOperators.includes(authUser.user.uid)) {
        return null;
    }
    return (_jsx(_Fragment, { children: enabled &&
            _jsxs("div", { className: "card", children: [_jsx("div", { className: "card-header", children: "Enable LTI 1.1" }), _jsxs("div", { className: "card-body", children: [errorMessage !== null && (_jsx(Alert, { type: "danger", message: errorMessage, dismissible: true, onDismiss: function () { return setErrorMessage(null); } })), _jsx("p", { children: "Enable legacy LTI 1.1 support for this account and provision a default key. A redeploy will be required after enabling." }), _jsx("div", { children: _jsxs("button", { className: "btn mr-2 btn-info", onClick: enableLegacyLTI, disabled: inSubmit, children: [inSubmit && _jsx(Loader, {}), 'Enable LTI 1.1 with default key'] }) })] })] }) }));
};
export default EnableLegacyLTI;
